import { ExternalLink } from "lucide-react";
import { EXTENSION_WEB_STORE_URL, EXTENSION_VERSION } from "../../constants";

interface ExtensionPageModalProps {
  showExtensionPage: boolean;
  onClose: () => void;
  t: (key: string) => string;
}

export function ExtensionPageModal({ showExtensionPage, onClose, t }: ExtensionPageModalProps) {
  if (!showExtensionPage) return null;

  return (
    <div className="fixed inset-0 z-[10001] flex items-center justify-center p-4 bg-black/70" onClick={onClose}>
      <div className="bg-[#0a0a0a] border border-white/15 rounded-xl shadow-2xl max-w-md w-full p-6 space-y-4" onClick={e => e.stopPropagation()}>
        <div className="flex items-center justify-between">
          <h2 className="text-lg font-bold text-white flex items-center gap-2">
            <ExternalLink size={20} /> {t('extension.title')}
          </h2>
          <button type="button" onClick={onClose} className="text-white/50 hover:text-white p-1" aria-label={t('common.close')}>×</button>
        </div>
        <p className="text-sm text-white/80">
          {t('extension.intro')}
        </p>
        <ol className="text-sm text-white/70 list-decimal list-inside space-y-2">
          <li>{t('extension.step1')}</li>
          <li>{t('extension.step2')}</li>
          <li>{t('extension.step3')}</li>
        </ol>
        <a
          href={EXTENSION_WEB_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-500 text-white font-semibold px-4 py-2.5 rounded-lg text-sm transition-colors"
        >
          <ExternalLink size={18} /> {t('extension.download').replace('{version}', EXTENSION_VERSION)}
        </a>
        <p className="text-sm text-white/50">
          {t('extension.compat')}
        </p>
        <button type="button" onClick={onClose} className="w-full py-2 text-sm text-white/60 hover:text-white border border-white/20 rounded-lg transition-colors">
          {t('extension.close')}
        </button>
      </div>
    </div>
  );
}
